"use client";

import HeroSection from "@/components/common/HeroSection";
import MiniCard from "@/components/common/MiniCard";
import { twMerge } from "tailwind-merge";
import { points } from "@/constants/ServicesAppData";
import ImageCard from "@/components/common/ImageCard";
import { ImageCardData } from "@/constants/UIUXData";
import { cardData } from "@/constants/WebApp";
import SectionHeader from "@/components/common/SectionHeader";
import CheckMarks from "@/components/common/CheckMarks";
import StatsCardsContainer from "@/components/StatCard";
import { useIsDark } from "@/context/ThemeContext";
import Button from "@/components/common/Button";

export default function MobileApp() {
  const isdark = useIsDark();

  return (
    <div className="relative flex flex-col justify-center items-center mt-6 z-10">
      <section className="mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150]">
        <HeroSection
          heading="MOBILE APP DEVELOPMENT"
          subHeading="Launch Fast. Learn Faster."
          paragraph="We believe the best apps are the ones people actually enjoy using. That’s why we focus on blending design, technology, and usability into every mobile solution we build."
          headingStyles="text-[35px] mobile:text-[45px] sm:text-[60px] md:text-[75px] tablet:text-[95px] lg:text-[105px] xl:text-[135px] laptop:text-[155px] 3xl:text-[190px] 4xl:text-[210px] leading-[100%] text-center"
        />
      </section>

      <section className="flex flex-col items-center mx-5 md:mx-[40px] xl:mx-[100px] 3xl:mx-[150]">
        <SectionHeader
          title={"WHAT WE DO"}
          wrapperClassName="xl:mt-[30px] xl:mb-0 px-0"
          titleClassName="xl:text-[35px]"
        />
        <div className="grid mobile:grid-cols-2 tablet:grid-cols-4 gap-[19px] md:gap-x-[35px] tablet:gap-4 xl:gap-[25px] 2xl:gap-[60px] xl:mt-[50px] mt-[30px] auto-rows-fr">
          {cardData.map((item, index) => (
            <MiniCard
              key={index}
              icon={item.icon}
              heading={item.heading}
              paragraph={item.paragraph}
              // cardStyles="md:pb-[35px] tablet:pb-[25px] tablet:px-3 lg:px-5 w-full xl:w-[296px] 3xl:w-[316px]"
              cardStyles="md:pb-[35px] tablet:pb-[25px] tablet:px-3 lg:px-5 w-full laptop:w-[296px] laptop:h-[480px] 3xl:w-full 3xl:h-full"
              headingStyles="tablet:text-[18px] lg:text-[20px]"
            />
          ))}
        </div>
      </section>

      <section
        className={twMerge(
          "flex flex-col items-center w-full py-[25px] xl:py-[50px] px-5 md:px-[40px] xl:px-[100px] mt-10 3xl:mt-15",
          isdark ? "bg-[#2D2D2D]/50" : "bg-[#F2E4FE]"
        )}
      >
        <div className="w-full max-w-[2000px]">
          <SectionHeader
            title={"Why WORK WITH US"}
            wrapperClassName="mt-0 mb-0 px-0"
            descriptionClassName="xl:mt-[50px]"
          />
          <div className="flex flex-col md:flex-row justify-between items-center mt-[25px] xl:mt-[50px]">
            <CheckMarks points={points} />
            <StatsCardsContainer gridStyles="p-2" cardStyles="md:w-[150px]" />
          </div>
        </div>
      </section>

      {/* <SectionHeader
        title={"SOME OF OUR WORK"}
        wrapperClassName="mt-[50px] mb-0"
      /> */}
      {/* <div className="w-full px-5 md:px-[40px] xl:px-[100px]"> */}
      {/* Card slider for small screens */}
      {/* <div className="flex w-full mobile:hidden gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar">
          {ImageCardData.map((item, index) => (
            <div
              key={index}
              className="flex-shrink-0 basis-[80%] small:basis-[65%]"
            >
              <ImageCard
                image={item.image}
                topic={item.topic}
                text={item.text}
                // tags={item.tags}
                sizes="(max-width: 480px) 80vw, 65vw"
                hoverOverlayColor="rgba(26, 26, 26, 0.2)"
              />
            </div>
          ))}
        </div>

        <div className="hidden mobile:grid mobile:grid-cols-2 tablet:grid-cols-3 w-full max-w-[2000px] gap-x-4 sm:gap-x-6 2xl:gap-x-8 3xl:gap-x-10 4xl:gap-x-12 gap-y-2 mt-[30px] mx-auto">
          {ImageCardData.map((item, index) => (
            <ImageCard
              key={index}
              image={item.image}
              topic={item.topic}
              text={item.text}
              tags={item.tags}
              sizes="(max-width: 768px) 50vw, 33vw"
              hoverOverlayColor="rgba(26, 26, 26, 0.2)"
            />
          ))}
        </div>
      </div> */}

      <section
        style={{
          transform: "translateZ(0)",
          willChange: "transform, opacity",
        }}
      >
        <SectionHeader
          title={"LET’S Build something together"}
          description={
            "Your customers are already on mobile, let’s meet them there. We’ll take your idea, shape it with the right technology, and craft an app people will actually enjoy using."
          }
          wrapperClassName="mt-25 mb-[50px]"
          titleClassName="text-[35px]"
          descriptionClassName="mt-[50px]"
        />
      </section>

      <div className="flex flex-col justify-center items-center">
        <Button
          label={
            <span className="flex items-center gap-1 text-sm sm:text-base md:text-lg lg:text-xl 2xl:text-[24px]">
              Got an idea in mind? Let’s talk
            </span>
          }
          className="max-w-full sm:w-[300] md:w-[380] lg:w-[426ps] h-[55px] sm:h-[60px] md:h-[65px] lg:h-[60px] mb-4 px-4 sm:px-6 md:px-8 lg:px-10"
          href="/contact#contact-form"
        />
      </div>
      {/* </div> */}
    </div>
  );
}
